import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Select, { components } from 'react-select'
import cx from 'classnames'

const styles = theme => ({
  selectFieldIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    position: 'relative',
    pointerEvents: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fontSize: 24,
    userSelect: 'none',
    flexShrink: 0,
    fill: 'rgba(0, 0, 0, 0.54)',
  },
})

const DropdownIndicator = withStyles(styles)(props => {
  const { classes } = props
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <svg
          className={cx(classes.selectFieldIcon)}
          fill="rgba(0, 0, 0, 0.54)"
          focusable="false"
          viewBox="0 0 24 24"
          aria-hidden="true"
          role="presentation"
        >
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </components.DropdownIndicator>
    )
  )
})

class MultiSelect extends React.Component {
  state = {
    focus: false,
  }

  handleBlur = () => {
    setTimeout(() => {
      this.props.input.onBlur(this.props.input.value)
    }, 1)
  }

  componentDidMount() {
    this.setState(() => {
      return { focus: false }
    })
  }

  render() {
    const { options, input, placeholder = 'Выберите...', meta } = this.props

    const customStyles = {
      placeholder: () => ({
        color: 'rgba(0, 0, 0, 0.3)',
        fontSize: 16,
      }),
      control: (provided, state) => ({
        alignItems: 'center',
        backgroundColor: '#ffffff',
        border: state.isFocused
          ? 'solid 1px #9371ff'
          : meta.invalid && meta.touched
          ? 'solid 1px red'
          : 'solid 1px rgb(187, 187, 187)',
        borderRadius: 4,
        cursor: 'pointer',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: 46,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        boxSizing: 'border-box',
        paddingLeft: 12,
      }),
    }

    return (
      <Select
        {...input}
        options={options}
        isMulti
        components={{ DropdownIndicator }}
        closeMenuOnSelect={false}
        onChange={value => input.onChange(value)}
        onBlur={this.handleBlur}
        placeholder={placeholder}
        noOptionsMessage={() => 'Нет опций'}
        styles={customStyles}
        autoFocus={this.state.focus}
      />
    )
  }
}

// const MultiSelect = ({ options, input, placeholder = 'Выберите...' }) => {
//   const handleBlur = () => {
//     setTimeout(() => {
//       input.onBlur(input.value)
//     }, 1)
//   }

//   return (
//     <Select
//       {...input}
//       options={options}
//       isMulti
//       components={{ DropdownIndicator }}
//       closeMenuOnSelect={false}
//       onChange={value => input.onChange(value)}
//       onBlur={handleBlur}
//       placeholder={placeholder}
//       noOptionsMessage={() => 'Нет опций'}
//       styles={customStyles}
//     />
//   )
// }

export default withStyles(styles)(MultiSelect)
